// Deterministic initial-letter avatar derived from the entry title.
// Used by list rows and the detail header when no favicon is stored.
// Pure: no DOM, no I/O.

export function avatarFor(title) {
  const s = typeof title === 'string' ? title.trimStart() : '';
  if (s.length === 0) return { initial: '?', hue: 0 };

  // Preserve surrogate pairs (emoji titles).
  const cp = s.codePointAt(0);
  const initial = String.fromCodePoint(cp).toUpperCase();
  const hue = fnv1a32(s) % 360;
  return { initial, hue };
}

// FNV-1a 32-bit string hash. Small, deterministic, dependency-free.
function fnv1a32(s) {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  return h;
}
